
import { useState, useMemo, useEffect, useCallback, useContext } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom';
import { sortRows, filterRows, paginateRows } from '../helpers'
import Pagination from '../Pagination'
import CompanyLogo from '../CompanyLogo';
import SortIcon from 'mdi-react/SortIcon'
import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import '../TableView.css'
import { routeNames } from '../../routeSegments';
import RandomLogo from '../RandomLogo';
import OverflowToolTip from '../shared/OverflowToolTip';
import { rowsPerPageData, maAcquirerListApi, getPEGlobalSearchCompaniesApi } from '../../Config/config'
import { TableDataContext } from '../../Contexts/TableDataContext'
import axios from "axios";
import CustomNavigation from '../../Utils/CustomNavigation';
import NoDataPlaceholder from '../shared/NoDataPlaceholder';
import Loader from '../Loader';
import { UserContext } from '../../Contexts/UserContext';
import AddNotePopover from '../shared/AddNotePopover';
import Constants from '../../Constants';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import moment from "moment";
import { useRef } from 'react';
import DeleteItemsFromGroup from '../shared/DeleteItemsFromGroup';
import { toast } from 'react-toastify';
import TwolineOverflowToolTip from '../shared/TwolineOverflowToolTip';
import NewLogo from '../NewLogo';
import LZString from "lz-string"

/**
 * The `Table` component is a JavaScript function that renders a table based on the provided columns,
 * menu, month, order, and orderBy parameters.
 * @returns The `Table` component is being returned.
 */
const Table = ({ columns, menu, month, order, orderBy,sub_type_master_id }) => {

  const { rows, setRows, data, setData, isLoad, setIsLoad, isDataLoad, setIsDataLoad, totalNoOfCompanies, setTotalNoOfCompanies, currency, setTableAcquirerId, currentPage, setCurrentPage,setCurrentFilter, setAllDealIds, globalSearchResult, setGlobalSearchResult} = useContext(TableDataContext);
  const { monthPickerValue, setMonthPickerValue, isMonthPickerChanged, setIsMonthPickerChanged, isTagClosed, setIsTagClosed,  refineSearchFilters: contextRefineSearchFilters,
    setRefineSearchFilters: contextSetRefineSearchFilters ,groupId} = useContext(PeFilterContext);
  const [activePage, setActivePage] = useState(currentPage)
  const [filters, setFilters] = useState({})
  const [refineSearchFilters, setRefineSearchFilters] = useState(contextRefineSearchFilters || {})
    const [urlDates, setUrlDates] = useState(null) // Store URL dates directly
    const [isDataReady, setIsDataReady] = useState(false)
  
  const [sort, setSort] = useState({ order: order, orderBy: orderBy })
  // const [sort, setSort] = useState({ order: 'asc', orderBy: 'acquirer_name' })
  const [showId, setShowId] = useState(null);
  const [showNote, setShowNote] = useState(false)
  const { getToken, logout } = useContext(UserContext);
  const abortRef = useRef(null)
  var location = useLocation();
  const[reload, setReload] = useState(false)

  /**
   * The function `findActivePage` sets the current page, renders a table with specified parameters,
   * and sets a flag indicating that the page is loading.
   * @param page - The "page" parameter represents the current page number.
   */
  const findActivePage = (page) => {
    setCurrentPage(page)
    tableRender(page, monthPickerValue, sort.orderBy, sort.order,groupId)
    setIsLoad(true)
  }
  // Process all URL parameters and set all necessary data in one effect
  useEffect(() => {
    console.log("Processing URL parameters and setting up data...")

    const queryParams = new URLSearchParams(location.search)
    let processedFilters = {} // Start with an empty object for URL filters
    let extractedDates = null

    // Handle 'filters' param
    const compressed = queryParams.get("filters")
    if (compressed) {
      try {
        const decompressed = LZString.decompressFromEncodedURIComponent(compressed)
        const urlFilters = JSON.parse(decompressed)
        processedFilters = urlFilters
        console.log("Processed filters from URL:", urlFilters)
      } catch (error) {
        console.error("Error decompressing or parsing filters:", error)
      }
    }
    // Handle 'gs' param (globalSearchResult)
      const gsCompressed = queryParams.get('gs');
      if (gsCompressed) {
        try {
          const gsDecompressed = LZString.decompressFromEncodedURIComponent(gsCompressed);
          const gsData = JSON.parse(gsDecompressed);
          
          console.log('Retrieved globalSearchResult from URL:', gsData);
          if (gsData && Object.keys(gsData).length > 0) {
            // Set the data in the context
            setGlobalSearchResult(gsData);
            console.log('Set globalSearchResult in context from URL param:', gsData);
            
            // Create a globalSearch entry in refineSearchFilters to trigger the right condition
            const pathKey = location.pathname;
            const updatedFilters = {...refineSearchFilters};
            
            if (!updatedFilters[pathKey]) {
              updatedFilters[pathKey] = {};
            }
            
            updatedFilters[pathKey].globalSearch = ['1']; // Set it to have length 1
            setRefineSearchFilters(updatedFilters);
          }
        } catch (error) {
          console.error('Error decompressing or parsing globalSearchResult:', error);
        }
      }
    // Handle 'date' param - extract and store directly
    const dateParam = queryParams.get("date")
    if (dateParam) {
      console.log("Found date parameter:", dateParam)
      const [startStr, endStr] = dateParam.split(",")
      const startDate = moment(startStr, "YYYY-MM-DD")
      const endDate = moment(endStr, "YYYY-MM-DD")

      if (startDate.isValid() && endDate.isValid()) {
        // Store dates directly for API use
        extractedDates = {
          from_date: startDate.format("YYYY-MM-DD"),
          to_date: endDate.format("YYYY-MM-DD"),
        }
        console.log("Extracted dates from URL:", extractedDates)
        setUrlDates(extractedDates)
      } else {
        console.warn("Invalid date format in query params:", { startStr, endStr })
      }
    }

    // Set local and context refineSearchFilters first
    console.log("Setting refineSearchFilters:", processedFilters)
    setRefineSearchFilters(processedFilters)


    // Mark data as ready for API call
    setIsDataReady(true)

    console.log("URL processing complete. Data ready for API call.", {
      extractedDates,
      processedFilters,
    })
  }, [location.search]) // Only depend on location.search

  console.log('refineSearchFiltersma', refineSearchFilters[location.pathname]);
  const isFromGlobalSearch = ()=> globalSearchResult?.length === 0 ? false : true

  /* The above code is a JavaScript function that uses the `useCallback` hook. It is a table rendering
  function that makes an API call to fetch data based on the provided parameters (page, month,
  column, order). */
  const tableRender = useCallback((page, month, column, order) => {
    console.log(month, 'm usecallback month'); 
// Use URL dates if available, otherwise fall back to monthPickerValue
          let dateRange
          if (urlDates) {
            dateRange = urlDates
            console.log("Using URL dates for API call:", dateRange)
          } else if (monthPickerValue && Array.isArray(monthPickerValue) && monthPickerValue.length === 2) {
            dateRange = {
              from_date: moment(monthPickerValue[0]).format("YYYY-MM-DD"),
              to_date: moment(monthPickerValue[1]).format("YYYY-MM-DD"),
            }
            console.log("Using monthPickerValue for API call:", dateRange)
          } else {
            console.log("No valid dates available for API call, using default or empty.")
            // Provide a default or empty date range if none is found
            dateRange = { from_date: null, to_date: null }
          }
    setIsTagClosed(0)
    setIsMonthPickerChanged(0)
    axios(`${maAcquirerListApi}`, {
      method: "POST",
      signal: abortRef.current.signal,
      data:{
        from: isFromGlobalSearch() ? "gs" : "",
        date_range:dateRange,
        "page": page,
        "per_page": 200,
        "order_by": { "column": column, "direction": order },
        acquirerIds: isFromGlobalSearch() ? 
          globalSearchResult.pe_acquirer !== 0 ? globalSearchResult?.pe_acquirer : [] 
          : refineSearchFilters[location.pathname.endsWith('/all')? location.pathname.substring(0, location.pathname.lastIndexOf('/')): location.pathname]?.globalSearch?.at(0)?.value,
        group:{  
          group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null,
          sub_type_master_id: groupId?.myList?.length >0 ? sub_type_master_id :null   
        }
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },

    })
      .then((response) => {
        if (response?.data?.message == "Success") {
          // console.log(response,'cfs table response');      
          setCurrentFilter(response.config.data) 
          setTotalNoOfCompanies(response?.data?.num_acquirers)
          setIsLoad(false)
          setIsDataLoad(false)
          // setIsMonthPickerChanged(0)
          setRows([])
          setRows(response?.data?.companies)
          
          setData(response?.data)
          setTableAcquirerId(response?.data?.all_acquirer_ids)
          setAllDealIds(response?.data?.all_deal_ids)
          console.log(response?.data, 'cfs table response');
        }
      })
      .catch((error) => {
        if (error?.response?.status == Constants.sessionTerminatedStatus 
            || error?.response?.status == Constants.InvalidTokenStatus
          ){
          logout();
        }
        console.log("API not working", error);
      });
  }, [refineSearchFilters]);


  useEffect(() => {
    const abortController = new AbortController()
    abortRef.current = abortController;
    setIsLoad(true)
    setIsDataLoad(true)
    setCurrentPage(currentPage);
    tableRender(currentPage, monthPickerValue, sort.orderBy, sort.order,groupId )
    return () => {
      abortController.abort();
    }
  }, [tableRender, monthPickerValue,groupId ,reload]);

  /**
   * The addNote function toggles the visibility of a note and sets the id of the note to be shown.
   * @param id - The `id` parameter is the identifier of the note that needs to be added.
   */
  const addNote = (id) => {
    setShowNote(!showNote)
    setShowId(id)
  }

  const rowsPerPage = rowsPerPageData

  const filteredRows = useMemo(() => filterRows(rows, filters), [rows, filters])
  // const sortedRows = useMemo(() => sortRows(filteredRows, sort), [filteredRows, sort])
  // const calculatedRows = paginateRows(sortedRows, currentPage, rowsPerPage)
  // console.log(calculatedRows, "cfs calculated")

  /**
   * The function `handleSort` is used to handle sorting of data in a table based on a given accessor
   * and order.
   * @param accessor - The `accessor` parameter is a value that represents the property or key of the
   * object that you want to sort by. It is used to identify the specific property or key that you want
   * to sort the data by.
   * @param order - The "order" parameter is used to specify the sorting order. It can have two
   * possible values: 'asc' for ascending order and 'desc' for descending order.
   */
const handleSort = (accessor) => {
  setCurrentPage(currentPage); // Assuming currentPage is defined elsewhere
  setRows([]);
  setIsLoad(true);
  setIsDataLoad(true);

  const isNumericColumn = ["acquisitions", "total_acquistions"].includes(accessor);

  setSort((prevSort) => {
    const isSameColumn = prevSort.orderBy === accessor;
    const newOrder = isSameColumn
      ? prevSort.order === 'desc' ? 'asc' : 'desc'
      : isNumericColumn ? 'desc' : 'asc'; // Default to 'desc' for numeric columns, 'asc' for others

    // Call tableRender with the new order
    tableRender(currentPage, monthPickerValue, accessor, newOrder, groupId);

    return {
      order: newOrder,
      orderBy: accessor,
    };
  });
};
  const count = filteredRows.length
  // const totalPages = Math.ceil(count / rowsPerPage)

  console.log(count, filteredRows, 'count');

  var location = useLocation();


 /**
  * The function `addCommasToNumber` takes a number as input and returns a string representation of the
  * number with commas added for thousands separators.
  * @param number - The `number` parameter is the number to which commas need to be added.
  * @returns The function `addCommasToNumber` returns a string with commas added to the number.
  */
  const addCommasToNumber = (number) => {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  
    useEffect(()=>{
    console.log(location?.state?.isFromGlobalSearch, 'isFromGlobalSearch');

  },[location?.state?.isFromGlobalSearch])

  return (
    <>
      <div className="md:col-span-4 col-span-5">
        <div className="lg:col-span-4">
          <div className="scrollbar ">
             <div className={"overflow-x-auto scrollbar rounded-b-[6px] "+(rows.length > 5 ? '':'pr-2')}>
              <table className="listPage table w-full p-1 bg-grey-50 divide-y" width="50%">
                <thead className="bg-[#EBEBEB] text-[11pt] leading-[16pt] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666]  text-left">
                  <tr>
                    {columns.map((column, i) => {
                      const sortIcon = () => {
                        if (column.accessor === sort.orderBy) {
                          if (sort.order === 'asc') {
                            return <SortDescendingIcon className="pl-2 block h-[15px]" />
                          }
                          return <SortAscendingIcon className="pl-2 block h-[15px]" />
                        } else {
                          return <SortIcon className="pl-2 block h-[15px] " />
                        }
                      }
                      return (

                        <th className={i === 0 ? "md:pl-5 md:pr-5 pl-5 pr-[9rem]" : "px-5 " + " py-2 font-sans_book_body"} key={i}>
                          <span className="flex whitespace-nowrap"> 
                            <OverflowToolTip className="hover:text-[#000000] cursor-auto" component={
                              <a className="hover:text-[#000000] cursor-auto">
                                {column.accessor === "add" && groupId?.myList?.length > 0 ? "Delete" :
                                  column.accessor === "add" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Create</span>
                                      <span>your list</span>
                                    </div>
                                  ) : column.accessor === "total_acquistions" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Total Acquisitions</span>
                                      <span>(US$ M)</span>
                                    </div>
                                  ) : column.label ? column.label : "--"}
                              </a>
                            } />
                            {column.accessor !== "add" && (
                              <button onClick={() => handleSort(column.accessor, sort.order)}>
                                {sortIcon()}
                              </button>
                            )}
                          </span>
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                {!isLoad ?
                  count > 0 ?
                    <tbody className="text-[11pt] leading-[16pt] lg:text-[14px] lg:leading-[16px] font-sans_book_body text-[#333333] text-left">
                      {rows.length > 0 ?
                        rows?.map((row, i) => {
                          return (
                            <tr key={i} className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]   border-b bg-white text" >
                            <td className="w-[21%] 2xl:w-[10%] leading-relaxed font-medium px-5 py-3 font-sans_book_body card-animate">
                              <div className="flex items-center">
                                <NewLogo id={row.acquirer_id} name={row.acquirer_name} menu={"ma_acquirer"} />

                                <OverflowToolTip
                                  className="w-[10rem] lg:max-w-[18rem]"
                                  component={
                                    <NavLink
                                      className="flex text-start lg:inline leading-[1.1rem] lg:whitespace-normal break-words hover:text-[#BC8B20] font-medium"
                                      state={{ prevPath: location.pathname }}
                                      to={routeNames.maAcquiresById(row.acquirer_id)}
                                    >
                                      {row?.acquirer_name ? row.acquirer_name : "--"}
                                    </NavLink>
                                  }
                                />
                              </div>
                            </td>
                              <td className="w-[5%] py-3 font-sans_book_body text-right px-5 pr-[2.8rem] lg:pr-[2.7rem] 2xl:pr-[3.7rem] ">
                                {row.acquisitions ? addCommasToNumber(row.acquisitions) : "--"}
                              </td>
                              <td className="w-[18%] py-3 px-5 font-medium font-sans_book_body whitespace-normal break-words">
                                <TwolineOverflowToolTip
                                  className="w-[10rem] line-clamp-2 leading-relaxed"
                                  component={
                                    row?.top_acquistion?.length > 0 ? (
                                      <span className="whitespace-normal break-words">
                                        {row?.top_acquistion?.map((company, i) => (
                                          <CustomNavigation
                                            key={company?.company_id}
                                            module="company"
                                            mainModule="ma"
                                            name={company.target_company + (i === row?.top_acquistion?.length - 1 ? "" : ", ")}
                                            entityId={company?.company_id}
                                          />
                                        ))}
                                      </span>
                                    ) : (
                                      "--"
                                    )
                                  }
                                />
                              </td>

                              <td className="w-[10%] py-3 px-5 font-medium font-sans_book_body whitespace-normal break-words">
                                <TwolineOverflowToolTip
                                  className="w-[10rem] lg:max-w-[18rem] line-clamp-2 leading-relaxed"
                                  component={
                                    <Link
                                      rel="noopener noreferrer"
                                      className="flex text-start lg:inline whitespace-normal break-words hover:text-[#BC8B20]"
                                      to={routeNames.maCompanyById(row?.last_acquirer)}
                                    >
                                      {row.last_acquired ? row.last_acquired : "--"}
                                    </Link>
                                  }
                                />
                              </td>

                              <td className=" w-[4%] min-w-[140px] py-3 font-sans_book_body text-right pr-[2.8rem]  xl:pr-[3rem] 2xl:pr-[3.5rem]">
                                <p>{row.total_acquistions != 0.00 ? addCommasToNumber(row.total_acquistions) : "--"}</p>
                              </td>
                              <td className={groupId?.myList?.length >0 ?"w-[5%] px-5 py-3 font-sans_book_body pl-1":"w-[5%] px-5 py-3 font-sans_book_body " }>
                              {groupId?.myList?.length >0 ? 
                                 <DeleteItemsFromGroup id={row.company_id} group_id={row?.grp_lt_item_id} type_id={Constants.moduleIds.acquirer_id} setReload={setReload}/>
                                 :<AddNotePopover className="" key={row.acquirer_id} companyId={row.acquirer_id} companyName={row.acquirer_name} type_id={Constants.moduleIds.acquirer_id} sub_type_master_id={sub_type_master_id}/>

                        }</td>
                            </tr>
                          )
                        })
                        : <center><div className="h-[4rem] text-[12pt] lg:text-[15px] text-[15px] text-[#333333] relative mt-[3rem] left-[30rem]">No data found</div></center>
                      }
                    </tbody>
                    : <></>
                  : <></>
                }
              </table>

              {!isLoad ?
                count > 0 ?
                  <></>
                  : <div className='pr-2'>
                  <div className='w-full h-[17rem] bg-white flex items-center justify-center fixed md:relative'>
                    <NoDataPlaceholder />
                  </div>
                  </div>
                :
                <div className='w-full h-[17rem] bg-white flex items-center justify-center absolute md:relative'>
                  <Loader />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      
    </>
  )
}

export default Table
